import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import client from "./client.module";
import user from "./user.module";
import rol from "./rol.module";
import stats from "./stats.module";
import payment from "./payment.module";
import account from "./account.module";
import company from "./company.module";
import jira from "./jira.module";
import breadcrumbs from "./breadcrumbs.module";
import conversionBanco from "./conversionBanco.module";
import envioDocumento from "./envioDocumento.module"
import tipoDocumento from "./tipoDocumento.module"
import configuracion from "./configuracion.module"
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    client,
    user,
    rol,
    stats,
    payment,
    account,
    company,
    jira,
    breadcrumbs,
    conversionBanco,
    envioDocumento,
    tipoDocumento,
    configuracion
  }
});
